import { v4 as uuidv4 } from 'uuid';
import { preloadImages, commonImagesList } from '../../../../commons/utils/imagePreloader';

function finalizeSessionInit({ params, authSession }) {
    if (this.isOauth(params)) {
        this.persistOauthInfo({ session: authSession, params });
    }

    const newSession = this.persistToken({ params });
    if (newSession) {
        this.session = newSession;
    } else {
        this.session = authSession;
    }

    this.redirectToHome(params);
    preloadImages(commonImagesList());
    this.observed.initialized = uuidv4();
}

export function redirectToHome(params) {
    // EcalWorld has no /home route — stay on current page (world/discovery)
    // Only navigate if coming back from an OAuth redirect (path is /login or empty)
    const path = this.page?.path || '/';
    if (path === '/login') {
        this.navigate('/');
    }
}

export default finalizeSessionInit;
